import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getInstruction,getCustomerNumber2,saveInstruction,getCustomerMember } from '../apiRequests/secreteryRequest'

function* handleInstructionData(action) {
    try {
        const response = yield call(getInstruction, action.params)
        yield put({
            type: types.GET_INSTRUCTION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_INSTRUCTION_ERROR,
            error: error.response,
        })
    }
}

function* handleCustomerData(action) {
    try {
        const response = yield call(getCustomerNumber2, action.params)
        yield put({
            type: types.GET_CUSTOMER_NUMBER2_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CUSTOMER_NUMBER2_ERROR,
            error: error.response,
        })
    }
}

function* handleSaveInstruction(action) {
    try {
        const response = yield call(saveInstruction, action.params)
        yield put({
            type: types.SAVE_INSTRUCTION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SAVE_INSTRUCTION_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCustomerMember(action) {
    try {
        const response = yield call(getCustomerMember, action.params)
        yield put({
            type: types.GET_CUSTOM_MEMBER_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CUSTOM_MEMBER_ERROR,
            error: error.response,
        })
    }
}



function* watcherSecreterySaga() {
    yield takeEvery(types.GET_INSTRUCTION_REQUEST, handleInstructionData)
    yield takeEvery(types.GET_CUSTOMER_MEMBER2_REQUEST, handleCustomerData)
    yield takeEvery(types.SAVE_INSTRUCTION_REQUEST, handleSaveInstruction)
    yield takeEvery(types.GET_CUSTOM_MEMBER_REQUEST, handleGetCustomerMember)

}

export default watcherSecreterySaga